export default __webpack_public_path__ + "static/media/misc-books2-480w.a1a299a4.webp";